export default {"src":"/_next/static/media/sports9.78c95843.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};